const DEFAULT_STOP = 600
const DEFAULT_STOPS = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950]

const MODES = [`hex`, `p-3`, 'oklch']

const DEFAULT_PALETTE_CONFIG = {
  id: ``,
  name: `primary`,
  value: ``,
  valueStop: DEFAULT_STOP,
  swatches: [],
  h: 0,
  s: 0,
  lMin: 7,
  lMax: 87,
  useLightness: true,
  mode: MODES[0],
}


function luminanceFromRGB(r, g, b) {
    // Formula from WCAG 2.0
    const [R, G, B] = [r, g, b].map(function (c) {
      c /= 255 // to 0-1 range
      return c < 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
    })
    return 21.26 * R + 71.52 * G + 7.22 * B
  }
  
function luminanceFromHex(H) {
    return round(luminanceFromRGB(...Object.values(hexToRGB(H))), 2)
  }

function unsignedModulo(x, n) {
    return ((x % n) + n) % n
  }

function round(value, precision) {
    const multiplier = Math.pow(10, precision)
    return Math.round(value * multiplier) / multiplier
  }

function clamp(x, min, max) {
    return Math.min(Math.max(x, min), max)
  }  

// TODO: Even out this function, luminance values aren't linear/good
function lightnessFromHSLum(H, S, Lum) {
    const vals = {}
    for (let L = 99; L >= 0; L--) {
      vals[L] = Math.abs(Lum - luminanceFromRGB(...Object.values(HSLtoRGB(H, S, L))))
    }
  
    // Run through all these and find the closest to 0
    let lowestDiff = 100
    let newL = 100
    for (let i = Object.keys(vals).length - 1; i >= 0; i--) {
      if (vals[i] < lowestDiff) {
        newL = i
        lowestDiff = vals[i]
      }
    }
  
    return newL
  }

  function HSLtoRGB(h, s, l) {
    s = clamp(s, 0, 100) / 100
    l = clamp(l, 0, 100) / 100
  
    const c = (1 - Math.abs(2 * l - 1)) * s
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1))
    const m = l - c / 2
    let r = 0
    let g = 0
    let b = 0
  
    if (h >= 0 && h < 60) {
      r = c
      g = x
      b = 0
    } else if (h >= 60 && h < 120) {
      r = x
      g = c
      b = 0
    } else if (h >= 120 && h < 180) {
      r = 0
      g = c
      b = x
    } else if (h >= 180 && h < 240) {
      r = 0
      g = x
      b = c
    } else if (h >= 240 && h < 300) {
      r = x
      g = 0
      b = c
    } else if (h >= 300 && h < 360) {
      r = c
      g = 0
      b = x
    }
  
    return {
      r: Math.round((r + m) * 255),
      g: Math.round((g + m) * 255),
      b: Math.round((b + m) * 255),
    }
  }

function hexToHSL(H) {
    if (H.length === 6 && !H.startsWith(`#`)) {
      H = `#${H}`
    }
  
    // Convert hex to RGB first
    let {r, g, b} = hexToRGB(H)
    // Then to HSL
    r /= 255
    g /= 255
    b /= 255
    const cmin = Math.min(r, g, b)
    const cmax = Math.max(r, g, b)
    const delta = cmax - cmin
    let h = 0
    let s = 0
    let l = 0
  
    if (delta === 0) h = 0
    else if (cmax === r) h = ((g - b) / delta) % 6
    else if (cmax === g) h = (b - r) / delta + 2
    else h = (r - g) / delta + 4
  
    h = Math.round(h * 60)
  
    if (h < 0) h += 360
  
    l = (cmax + cmin) / 2
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1))
    s = +(s * 100).toFixed(1)
    l = +(l * 100).toFixed(1)
  
    //   return `hsl(${h},${s}%,${l}%)`;
    return {h, s, l}
  }

function HSLToHex(h, s, l) {
    let {r, g, b} = HSLtoRGB(h, s, l)
  
    // Having obtained RGB, convert channels to hex
    r = r.toString(16)
    g = g.toString(16)
    b = b.toString(16)
  
    // Prepend 0s, if necessary
    if (r.length === 1) r = `0${r}`
    if (g.length === 1) g = `0${g}`
    if (b.length === 1) b = `0${b}`
  
    return `#${r}${g}${b}`
  }
  
function isHex(value) {
    const valueHex = value.length === 6 && !value.startsWith(`#`) ? `#${value}` : value
  
    const re = new RegExp(/^#[0-9A-F]{6}$/i)
  
    return re.test(valueHex.toUpperCase())
  }

function hexToRGB(H) {
    if (H.length === 6 && !H.startsWith(`#`)) {
      H = `#${H}`
    }
  
    let r = `0`
    let g = `0`
    let b = `0`
    if (H.length === 4) {
      r = `0x${H[1]}${H[1]}`
      g = `0x${H[2]}${H[2]}`
      b = `0x${H[3]}${H[3]}`
    } else if (H.length === 7) {
      r = `0x${H[1]}${H[2]}`
      g = `0x${H[3]}${H[4]}`
      b = `0x${H[5]}${H[6]}`
    }
  
    return {r, g, b}
  }

function createSaturationScale(tweak, stop) {
    const stops = DEFAULT_STOPS
    const index = stops.indexOf(stop)
  
    if (index === -1) {
      throw new Error(`Invalid key value: ${stop}`)
    }
  
    return stops.map((stop) => {
      const diff = Math.abs(stops.indexOf(stop) - index)
      const tweakValue = tweak ? Math.round((diff + 1) * tweak * (1 + diff / 10)) : 0
  
      if (tweakValue > 100) {
        return {stop, tweak: 100}
      }
  
      return {stop, tweak: tweakValue}
    })
  }
  
  export function createHueScale(tweak, stop) {
    const stops = DEFAULT_STOPS
    const index = stops.indexOf(stop)
  
    if (index === -1) {
      throw new Error(`Invalid parameter value: ${stop}`)
    }
  
    return stops.map((stop) => {
      const diff = Math.abs(stops.indexOf(stop) - index)
      const tweakValue = tweak ? diff * tweak : 0
  
      return {stop, tweak: tweakValue}
    })
  }
  
  export function createDistributionValues( min=0, max=100, lightness, stop) {
    const stops = DEFAULT_STOPS
  
    // Create known stops
    const newValues = [
    //   {stop: 0, tweak: max},
      {stop, tweak: lightness},
    //   {stop: 1000, tweak: min},
    ]
  
    // Create missing stops
    for (let i = 0; i < stops.length; i++) {
      const stopValue = stops[i]
        // console.log('stopvalue',stopValue)
      if (stopValue === 0 || stopValue === 1000 || stopValue === stop) {
        continue
      }
  
      const diff = Math.abs((stopValue - stop) / 100)
    //   console.log('diff',diff)

      const totalDiff =
        stopValue < stop
          ? Math.abs(stops.indexOf(stop) - stops.indexOf(DEFAULT_STOPS[0])) - 1
          : Math.abs(stops.indexOf(stop) - stops.indexOf(DEFAULT_STOPS[DEFAULT_STOPS.length - 1])) - 1
        //   console.log('totalDiff',totalDiff)

      const increment = stopValue < stop ? max - lightness : lightness - min
    //   console.log('increment',increment)

      const tweak =
        stopValue < stop
          ? (increment / totalDiff) * diff + lightness
          : lightness - (increment / totalDiff) * diff
        //   console.log('tweak',tweak)

      newValues.push({stop: stopValue, tweak: Math.round(tweak)})
    }
  
    newValues.sort((a, b) => a.stop - b.stop)
  
    return newValues
  }

export function createSwatches(palette) {
    const {value, valueStop} = palette
  
    // Tweaks may be passed in, otherwise use defaults
    const useLightness = DEFAULT_PALETTE_CONFIG.useLightness
    const h =  DEFAULT_PALETTE_CONFIG.h
    const s =  DEFAULT_PALETTE_CONFIG.s
    const lMin = DEFAULT_PALETTE_CONFIG.lMin
    const lMax =  DEFAULT_PALETTE_CONFIG.lMax
  
    // Create hue and saturation scales based on tweaks
    const hueScale = createHueScale(h, valueStop)
    const saturationScale = createSaturationScale(s, valueStop)
    // console.log('huescale',hueScale)
    // console.log('saturationScale',saturationScale)
    // Get the base hex's H/S/L values
    const {h: valueH, s: valueS, l: valueL} = hexToHSL(value)
    // console.log('hexToHSL(value)',hexToHSL(value))

    // Create lightness scales based on tweak + lightness/luminance of current value
    const lightnessValue = useLightness ? valueL : luminanceFromHex(value)
    // console.log('lightnessValue',lightnessValue)
    const distributionScale = createDistributionValues(lMin, lMax, lightnessValue, valueStop)
    // console.log('distributionScale',distributionScale)

    const swatches = hueScale.map(({stop}, stopIndex) => {
      const newH = unsignedModulo(valueH + hueScale[stopIndex].tweak, 360)
      const newS = clamp(valueS + saturationScale[stopIndex].tweak, 0, 100)
      let newL = useLightness
        ? distributionScale[stopIndex].tweak
        : lightnessFromHSLum(newH, newS, distributionScale[stopIndex].tweak)
      newL = clamp(newL, 0, 100)
  
      const newHex = HSLToHex(newH, newS, newL)
  
      return {
        stop,
        // Sometimes the initial value is changed slightly during conversion,
        // overriding that with the original value
        hex: stop === valueStop ? `${value.toUpperCase()}` : newHex.toUpperCase(),
        // Used in graphs
        h: newH,
        hScale: ((unsignedModulo(hueScale[stopIndex].tweak + 180, 360) - 180) / 180) * 50,
        s: newS,
        sScale: newS - 50,
        l: newL,
      }
    })
  
    return swatches
  }